import {Modal} from 'antd';
import {useSelector} from 'react-redux';

const TutorialModal = ({ visible, onComplete, onCancel }) => {
	const { tutorial } = useSelector((s) => s.auth);
	return (
		<Modal
			title="Quick start"
			visible={visible}
			okText="Mark as completed"
			onCancel={onCancel}
			cancelButtonProps={{
				hidden: true,
			}}
			onOk={() => {
				onComplete();
			}}
			width={1000}
		>
			{tutorial && tutorial.vimeo_embed_code && (
				<div
					dangerouslySetInnerHTML={{ __html: tutorial.vimeo_embed_code }}
				></div>
			)}
		</Modal>
	);
};

export default TutorialModal;
